const RECOVERABLE_CHUNK_PATTERNS = [
  /loading chunk [\w-]+ failed/i,
  /chunkloaderror/i,
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /unexpected end of script/i,
];

export const isRecoverableChunkLoadError = (error) => {
  if (!error) {
    return false;
  }

  const combinedMessage = [error.name, error.message]
    .filter(Boolean)
    .join(" ");

  return RECOVERABLE_CHUNK_PATTERNS.some((pattern) =>
    pattern.test(combinedMessage),
  );
};
